import { css } from '@emotion/react';

import { buttons, type ButtonProps, type ButtonTypes } from '~/components/Button';

interface SubmitButtonProps {
  autoWidth?: boolean;
  buttonType: ButtonTypes;
  preSubmitText: string;
  submittedSuccess: boolean;
  submitting: boolean;
  successSubmitText?: string;
}

const submitButtonStyle = css`
  min-width: 100px;
`;

const SubmitButton = (props: ButtonProps & SubmitButtonProps) => {
  const {
    autoWidth,
    buttonType,
    fullWidth,
    preSubmitText,
    submittedSuccess,
    submitting,
    successSubmitText,
    ...buttonProps
  } = props;
  const Button = buttons[buttonType];
  const text = submittedSuccess ? successSubmitText : preSubmitText;
  const css = !(autoWidth || fullWidth) ? submitButtonStyle : undefined;

  return (
    <Button css={css} fullWidth={fullWidth} isLoading={submitting} {...buttonProps}>
      {text}
    </Button>
  );
};

export default SubmitButton;
